import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { co } from '@fullcalendar/core/internal-common';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { CourseService } from 'src/app/services/course/course.service';
import { GlobalService } from 'src/app/services/global/global.service';

@Component({
  selector: 'app-add-exam',
  templateUrl: './add-exam.component.html',
  styleUrls: ['./add-exam.component.scss']
})
// Basic validation this component has ::

// 1.Should have exam tit -Required 
// 2. Qualify percentage -Required
// 3. Qualify marks should be between 0 and 100
// 4. Ask que 
// 5. You must enter at least ask question no. of questions
// 6. Question should have due and minimum two options 
// 7. Please select correct option..
// 8. Should have atleast 1 question to create exam

export class AddExamComponent {
  panelOpenState = false;
  files: File[] = [];

  public inputErr: any = {
    tit: false,
    q_m: false,
    as_q: false,
    correct_option: false,
    que: false,
    moreQuestion: [{
      qn: false,
      correct_answer_err: false,
      op_1: false,
      op_2: false,
      op_3: false,
      op_4: false,
      op_5: false,
    }]
  };
  public examDetailsData: any = {
    tit: '',
    q_m: '',
    as_q: '',
    que: [
      {
        qn: "",
        q_img: "",
        correct_answer: '',
        ans_t: "text",
        ansArr: [
          { option: "", correct: "" },
          { option: "", correct: "" },
          { option: "", correct: "" },
          { option: "", correct: "" }
        ]
      }
    ]
  };
  public currentQue: any
  public currentQueIndex: number = 1;
  public imagePath!: any;
  public courseId: any;
  public examId: any;
  public isEditExam: boolean = false;
  public isSpinnerLoading: boolean = false;
  public serverFileName: string = '';
  public imageURL = GlobalService.imageURL;
  public activeDiv:any={
    mainDiv:"",
    subDiv:""
  }
  private examType!:string;
  constructor(private cd: ChangeDetectorRef, private courseService: CourseService, private commonService: CommonService, public dialog: MatDialog,
    public dialogRef: MatDialogRef<AddExamComponent>, @Inject(MAT_DIALOG_DATA) public dialogData: any, private appService: AppService) { }
  ngOnInit(): void {
    let examId
    if(this.dialogData.e_i){
      examId=this.dialogData.e_i
    }
    else{
      examId=0
    }
    if (this.dialogData.c_i) {
      this.courseId = this.dialogData.c_i
      this.onViewExamAPI(this.dialogData.c_i, 'company',examId)
    }else{
      if (examId) {
          this.onViewExamAPI(null, 'company', examId)
       }
    }
   this.examType=this.dialogData.exam_type
  }
  onBack() { }
 
  onCopyQuestion(e: Event, item: any) {
    e.stopPropagation();
    item["question_id"]=""
    this.examDetailsData.que.push(JSON.parse(JSON.stringify(item)))
    this.addMoreQuestionErr()
  }
  onDeleteQuestion(e: Event, id: number) {
    e.stopPropagation();
    this.examDetailsData.que.splice(id, 1);
    this.inputErr.moreQuestion.splice(id, 1);
    if (this.currentQueIndex != 1) {
      this.currentQueIndex = this.currentQueIndex - 1;
    }
    this.currentQue = this.examDetailsData.que[this.currentQueIndex - 1];
  }
  onAddQuestion() {
    let obj = {
      question_text: "",
      q_img: "",
      ans_t: "text",
      ansArr: [
        { option: "", correct: "" },
        { option: "", correct: "" },
        { option: "", correct: "" },
        { option: "", correct: "" }
      ]
    }
    this.examDetailsData.que.push(obj)
    this.addMoreQuestionErr()
  }
  onTextChange(type: string) {
    // here as type we will get key name of object
    if (type != 'moreQuestion') {
      this.inputErr[type] = false;
      if (this.examDetailsData[type] == '') {
        this.inputErr[type] = true;
      }
      if (this.examDetailsData.as_q == 0) {
        this.inputErr.question = false;
      }
      if (this.examDetailsData.as_q < 0) {
        this.inputErr.as_q = true;
      }
      if ((this.examDetailsData.que.length > this.examDetailsData.as_q) ||
        (this.examDetailsData.que.length == this.examDetailsData.as_q)) {
        this.inputErr.question = false;
      }
      if (this.examDetailsData.que.length < this.examDetailsData.as_q) {
        this.inputErr.question = true;
      }
    }


    if (type == 'moreQuestion') {
      for (let i = 0; i < this.examDetailsData.que.length; i++) {
        if (this.examDetailsData.que[i].qn != '') {
          this.inputErr.moreQuestion[i].qn = false
        }
        else {
          this.inputErr.moreQuestion[i].qn = true
        }
      }
    }
  }
  addMoreQuestionErr() {
    this.inputErr.moreQuestion.push({
      qn: false,
      ans: false,
      op_1: false,
      op_2: false,
      op_3: false,
      op_4: false,
      op_5: false,
    });
  }
  onCheckCorrectAnswer(event: any, i: number, option_no: number) {
    this.examDetailsData.que[i].ansArr.map((i: any) => { i.correct = false })
    if (event.checked) {
      this.examDetailsData.que[i].correct_answer = option_no+1;
      this.examDetailsData.que[i].ansArr[option_no].correct = true;
      this.inputErr.moreQuestion[i].correct_answer_err = false;
    }
    else {
      this.inputErr.moreQuestion[i].correct_answer_err = true;
    }
  }
  onCurrentQue(item: any, id: number) {
    this.currentQueIndex = id + 1;
    this.currentQue = item;
    let answerArr: any[] = item.ansArr
    for (let j = 0; j < answerArr.length; j++) {
      if (answerArr[0].option === '') {
        this.inputErr.moreQuestion[id].op_1 = true;
      }
      else {
        this.inputErr.moreQuestion[id].op_1 = false;
      }
      if (answerArr[1].option === '') {
        this.inputErr.moreQuestion[id].op_2 = true;
      }
      else {
        this.inputErr.moreQuestion[id].op_2 = false;
      }
      if (answerArr[2].option === '') {
        this.inputErr.moreQuestion[id].op_3 = true;
      }
      else {
        this.inputErr.moreQuestion[id].op_3 = false;
      }
      if (answerArr[3].option === '') {
        this.inputErr.moreQuestion[id].op_4 = true;
      }
      else {
        this.inputErr.moreQuestion[id].op_4 = false;
      }
    }
  }

  onNavigateAnswer(type: any) {
    if (type == 'previous') {
      if (this.currentQueIndex != 1) {
        this.currentQueIndex = this.currentQueIndex - 1;
      }
    }
    if (type == 'next') {
      if (this.currentQueIndex <= this.examDetailsData.que.length) {
        this.currentQueIndex = this.currentQueIndex + 1;
      }
    }
    this.currentQue = this.examDetailsData.que[this.currentQueIndex - 1];
  }
  calculatePercentage() {
    return (this.currentQueIndex / this.examDetailsData.que.length) * 100
  }
  onSelect(event: any, main_index: number, sub_index: number) {
    this.activeDiv["mainDiv"]=main_index
    this.activeDiv["subDiv"]=sub_index
    
    this.files = [];
    this.files.push(...event.addedFiles);
    let fresult = this.files[0]
    this.examDetailsData.que[main_index].ansArr[sub_index].option = fresult;
    var reader = new FileReader();
    reader.readAsDataURL(fresult);
    reader.onload = (_event) => {
      this.examDetailsData.que[main_index].ansArr[sub_index]["optionPreview"] = reader.result;
      this.cd.markForCheck();
    }
    this.uploadFile(main_index, sub_index, "option_image");
    // this.examDetailsData.que[main_index].ansArr[sub_index]["optionPreview"]=this.getImage(fresult)
  }
  onSelectAttach(event: any, main_index: number) {
    this.activeDiv["mainDiv"]=main_index
    this.activeDiv["subDiv"]='attach'

    this.files = [];
    this.files.push(...event.addedFiles);
    let fresult = this.files[0]
    var reader = new FileReader();
    reader.readAsDataURL(fresult);
    reader.onload = (_event) => {
      this.examDetailsData.que[main_index]["attach_image"] = reader.result;
      this.cd.markForCheck();
    }
    this.uploadFile(main_index, "", "attach_image");
  }
  getImage(option: any) {
    if (option != '') {
      var reader = new FileReader();
      reader.readAsDataURL(option);
      reader.onload = (_event) => {
        this.imagePath = reader.result;
        this.cd.markForCheck();
      }
      return this.imagePath;
    }
    else {
      return ""
    }

  }
  onRemove(event: any) {
    this.files.splice(this.files.indexOf(event), 1);
  }
  onDeleteImage(item: any, type: string) {
    if (type == 'attach') {
      // item["attach_image"]=""
      this.onDeleteFile(item["q_img"], item, 'attach_image')
    }
    else {
      // if not attach image then it must be option image
      item["option"] = ""
      item["optionPreview"] = ""
      this.onDeleteFile(item["option"], item, 'option_image')
    }
    return item
  }
  onAnswerTypeChange(item: any) {
    item["correct_answer"] = "";
    item["ansArr"].map((item: any) => {
      item.option = '';
      item.correct = false;
      if (item.optionPreview) { item.optionPreview = '' }
    });
  }
  onReset() {
    this.currentQue=""
    this.examDetailsData={
      tit: '',
      q_m: '',
      as_q: '',
      que: [
        {
          qn: "",
          q_img: "",
          correct_answer: '',
          ans_t: "text",
          ansArr: [
            { option: "", correct: "" },
            { option: "", correct: "" },
            { option: "", correct: "" },
            { option: "", correct: "" }
          ]
        }
      ]
    }
  }
  onSave() {
    if (!this.examDetailsData.tit) {
      this.inputErr.tit = true;
    }
    if (!this.examDetailsData.q_m || (this.examDetailsData.q_m < 1 || this.examDetailsData.q_m > 100)) {
      this.inputErr.q_m = true;
    }
    if (!this.examDetailsData.as_q || this.examDetailsData.as_q < 1) {
      this.inputErr.as_q = true;
    }
    if (this.examDetailsData.que.length < this.examDetailsData.as_q) {
      this.inputErr.que = true;
    }
    let errorFlag=false
    for (let i = 0; i < this.examDetailsData.que.length; i++) {
      let data = this.examDetailsData.que[i];
      let flag = 0;
      if (data.qn == '' || (data.qn == null)) {
        this.inputErr.moreQuestion[i].qn = true;
        errorFlag=true;
      }
      if (data.correct_answer === ""||data.correct_answer==undefined) {
        this.inputErr.moreQuestion[i].correct_answer_err = true;
        errorFlag=true;
      }
      let answerArr: any[] = data.ansArr
      for (let j = 0; j < answerArr.length; j++) {
        if (answerArr[0].option === '') {
          this.inputErr.moreQuestion[i].op_1 = true;
          errorFlag=true;
        }
        if (answerArr[1].option === '') {
          this.inputErr.moreQuestion[i].op_2 = true;
          errorFlag=true;
        }
        if (answerArr[2].option === '') {
          this.inputErr.moreQuestion[i].op_3 = true;
          errorFlag=true;
        }
        if (answerArr[3].option === '') {
          this.inputErr.moreQuestion[i].op_4 = true;
          errorFlag=true;
        }
        
      }
    }
    if(errorFlag==true){
      return;
    }
    if (!this.examDetailsData.tit ||
      (!this.examDetailsData.q_m || (this.examDetailsData.q_m < 1 || this.examDetailsData.q_m > 100)) ||
      (!this.examDetailsData.as_q || this.examDetailsData.as_q < 1) ||
      (this.examDetailsData.que.length < this.examDetailsData.as_q)
    ) {
      return;
    }
    for(let k=0;k<this.inputErr.moreQuestion.length;k++){
      if(this.inputErr.moreQuestion[k].correct_answer_err==true){return}
    }
    let formData = new FormData()
    this.examDetailsData["login_type"] = "company"
    this.examDetailsData["c_i"] = this.courseId;
    this.examDetailsData["type"]=this.examType
    let newArr: any[] = this.examDetailsData["que"]
    newArr.map(item => {
      if (item["question_id"]) { }
      else { item["question_id"] = "" }
      item["q_img"]=item["attach_image"]
    })
    formData = this.commonService.convertToFormData(this.examDetailsData)
    if (this.isEditExam) {
      formData.append('c_i', this.courseId);
      formData.append('e_i', this.examId)
      this.onEditExamAPI(formData)
    }
    else {
      this.onSaveExamAPI(formData)
    }
  }
  onClose() {
    // this.dialog.closeAll()
    this.dialogRef.close()
  }
  onSaveExamAPI(obj: any) {
    let dataObj: {} = obj;

    // this.dialogRef.close({data_item:data})
    this.courseService.addExam(dataObj).subscribe((response: any) => {
      if (response["status"] == 200) {
        this.appService.showToastMessage('success', response["msg"])
        if(this.examType=='o_e'){
          this.dialogRef.close()
        }
        else{
         
    let data={
      e_i:response["e_i"],
      // sub_tit:'exam',
      sub_tit:this.examDetailsData.tit,
      subs_cont:'',
      type:'exam',
      o_stt:[],
    }
    this.courseService.updateSharedData(data);
     this.dialogRef.close()
        }
        
      }
    })
  }
  onViewExamAPI(id: any, login_type: any,e_i:any) {  
    let obj={
      c_i:id,
      login_type:login_type,
      e_i:e_i
    }        
    this.courseService.viewExam(obj).subscribe((response: any) => {
      if (response["status"] == 200) {
        if(response["msg"]["e_i"]){
          this.examId = response["msg"]["e_i"]
          this.isEditExam = true;
          this.examDetailsData = response.msg;
          let newArr: any[] = this.examDetailsData["que"];
          // newArr.map(item=>item["que"])
          for (let i = 0; i < (newArr.length) - 1; i++) {
            this.addMoreQuestionErr()
          }
          this.currentQue = this.examDetailsData.que[0];
        }
       }
     }
     )
  }
  onEditExamAPI(dataObj: any) {

    this.courseService.editExam(dataObj).subscribe((response: any) => {
      this.appService.showToastMessage('success', response["msg"])
      this.dialogRef.close()
    })
  }
  onDeleteFile(fileName: any, item: any, type: string) {
    let formData = new FormData();
    formData.append('ex_file', fileName)
    formData.append('content_name', 'exam')
    formData.append('obj_file', '')
    this.courseService.uploadFile(formData).subscribe((response: any) => {
      if (response["status"] == 200) {
        if (type == 'attach_image') {
          item["attach_image"] = ""
          item["q_img"] = ""
        }
        if (type == "option_image") {
          item["option"] = ""
          item["optionPreview"] = ""
        }
      }
    })
  }
  uploadFile(main_index: any, sub_index: any, image_type: String) {
    // this.spinner.show()
    this.isSpinnerLoading = true;
    let formData = new FormData();
    formData.append('ex_file', '')
    formData.append('content_name', 'exam')
    formData.append('obj_file', this.files[0])
    this.courseService.uploadFile(formData).subscribe((response: any) => {
      if (image_type == 'attach_image') {
        this.examDetailsData.que[main_index]["attach_image"] = response.msg;
        this.examDetailsData.que[main_index]["q_img"] = response.msg;
      }
      if (image_type == 'option_image') {
        this.examDetailsData.que[main_index].ansArr[sub_index].option = response.msg;
        this.examDetailsData.que[main_index].ansArr[sub_index]["optionPreview"] = response.msg;
        // adding this function here so that when user select image as answer type and option is now fileld with image then using this function it will remove the error
        this.onCurrentQue(this.examDetailsData.que[main_index],main_index)
      }
      this.isSpinnerLoading = false;
      this.serverFileName = response.msg;
    })
  }

  mainDrop(event: CdkDragDrop<string[]>) {
    // moveItemInArray(this.selectedCourse.sections, event.previousIndex, event.currentIndex);
    moveItemInArray(this.examDetailsData.que, event.previousIndex, event.currentIndex);
  }
}
